<template>
  <form class="save-template-form" @submit.prevent="onSubmit">
    <p>
      Wanneer u uw instellingen bewaart kunt u deze bij een volgende opdracht
      eenvoudig opnieuw toepassen op uw bestanden.
    </p>
    <p>Geef een naam op voor de te bewaren instellingen:</p>
    <input
      type="text"
      class="grey-field"
      placeholder="Typ hier een naam"
      v-model="localTemplateName"
    />
    <p class="default-option" v-if="format != 'Als bestand'">
      <select-box :selected="default" @action="makeDefault"></select-box
      ><span @click="makeDefault" class="pointer"
        >Default voor bestandsformaat {{ format }}</span
      >
    </p>
    <div class="button-container">
      <button class="pill-button secondary" type="button" @click="onCancel">
        Annuleren
      </button>
      <button class="pill-button" type="submit" :disabled="!localTemplateName">
        Bewaren
      </button>
    </div>
  </form>
</template>

<script>
export default {
  name: 'SaveTemplateForm',
  props: ['format'],
  data() {
    return {
      localTemplateName: '',
      default: false
    }
  },
  methods: {
    makeDefault() {
      this.default = !this.default
    },
    onSubmit() {
      this.$emit('save', this.localTemplateName, this.default)
      this.localTemplateName = ''
    },
    onCancel() {
      this.localTemplateName = ''
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.save-template-form {
  p {
    padding-bottom: 15px;
  }

  input {
    width: 100%;
    margin-bottom: 15px;
  }

  .button-container {
    padding-top: 15px;
    text-align: right;
  }

  .secondary {
    margin-right: 5px;
  }
}

p.default-option {
  padding-bottom: 0;
}
</style>
